export default function getHeader(
    response: Response | undefined,
    headerKey: string
): string | null | undefined {
    return response?.headers && response.headers.get(headerKey);
}
